
import React, { Component } from 'react';

// ...
import Scroll, { Events } from 'react-scroll';

import appData from './app_data/index';
import NavBar from './components/nav_bar/index';
import Intro from './components/intro/index';
import Services from './components/services/index';
import Stacks from './components/stacks/index';
import Projects from './components/projects/index';
import Contact from './components/contact/index';
import Footer from './components/footer/index';

import API from './lib/api';

import './App.css';

class App extends Component {
  state = {
    scrolledPastLimit: null
  }

  updateScroll = () => {
    const scroll = document.documentElement.scrollTop || document.body.scrollTop;
    const limit = 50;

    this.setState({ ...this.state, scrolledPastLimit: scroll > limit });
  }

  componentDidMount = () => {
    API.ping();

    window.addEventListener('scroll', this.updateScroll);

    Events.scrollEvent.register('begin', () => {
      // console.log('begin', arguments);
    });

    Events.scrollEvent.register('end', () => {
      // console.log('end', arguments);
    });

    Scroll.scrollSpy.update();
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.updateScroll);

    Events.scrollEvent.remove('begin');
    Events.scrollEvent.remove('end');
  }

  scrollToTop = () => {
    Scroll.animateScroll.scrollToTop();
  }

  render() {
    return (
      <div id="app">
        <NavBar
          scrolledPastLimit={this.state.scrolledPastLimit}
          appData={appData}
        />

        <main>
          <Intro appData={appData} />

          <Services />

          <Stacks />

          <Projects />

          <Contact />

          <Footer />
        </main>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js